/**
 * InvoiceTotals Component
 * 
 * Displays the invoice summary totals (subtotal, tax, total).
 * Shared between InvoiceForm and InvoiceDetail (DRY).
 */
import React from 'react';
import { formatAmount } from '../../utils/invoiceUtils';

interface InvoiceTotalsProps {
  /** Subtotal (before tax) */
  subtotal: number;
  /** Tax amount */
  tax: number;
  /** Grand total (including tax) */
  total: number;
  /** Whether to show tax percentage */
  showTaxPercentage?: boolean;
}

const InvoiceTotals: React.FC<InvoiceTotalsProps> = ({
  subtotal,
  tax,
  total,
  showTaxPercentage = true,
}) => {
  const taxPercentage = subtotal > 0 ? ((tax / subtotal) * 100).toFixed(0) : '0';

  return (
    <div className="invoice-summary">
      <div className="invoice-summary-row">
        <span className="summary-label">Subtotal</span>
        <span className="summary-value">{formatAmount(subtotal)}</span>
      </div>
      <div className="invoice-summary-row">
        <span className="summary-label">
          Tax{showTaxPercentage && subtotal > 0 ? ` (${taxPercentage}%)` : ''}
        </span>
        <span className="summary-value">{formatAmount(tax)}</span>
      </div>
      <div className="invoice-summary-row invoice-summary-total">
        <span className="summary-label">Total</span>
        <span className="summary-value">{formatAmount(total)}</span>
      </div>
    </div>
  );
};

export default InvoiceTotals;
